import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AppUpdateService } from '../../services/app-update.service';
import { IonicModule } from '@ionic/angular';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
    selector: 'app-update-banner',
    templateUrl: './update-banner.component.html',
    styleUrls: ['./update-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        IonicModule,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class UpdateBannerComponent {
  private readonly appUpdate = inject(AppUpdateService);
  readonly updateAvailable$ = this.appUpdate.updateAvailable$;
  isReloading = false;

  async reload(): Promise<void> {
    if (this.isReloading) {
      return;
    }

    this.isReloading = true;
    await this.appUpdate.applyUpdate();
  }
}
